export const countiesOfUK = [
  {
    region: 'England',
    counties: [
      'Bedfordshire',
      'Berkshire',
      'Buckinghamshire',
      'Cambridgeshire',
      'Cheshire',
      'Cornwall',
      'Cumbria',
      'Derbyshire',
      'Devon',
      'Dorset',
      'Durham',
      'East Riding',
      'East Sussex',
      'East Yorkshire',
      'Essex',
      'Gloucestershire',
      'Greater London',
      'Hampshire',
      'Herefordshire',
      'Hertfordshire',
      'Huntingdonshire',
      'Kent',
      'Lancashire',
      'Leicestershire',
      'Lincolnshire',
      'Merseyside',
      'Middlesex',
      'Norfolk',
      'North Yorkshire',
      'Northamptonshire',
      'Northumberland',
      'Nottinghamshire',
      'Oxfordshire',
      'Rutland',
      'Shropshire',
      'Somerset',
      'South Yorkshire',
      'Staffordshire',
      'Suffolk',
      'Surrey',
      'Tyne and Wear',
      'Warwickshire',
      'Westmorland',
      'Wiltshire',
      'Worcestershire',
      'West Sussex',
      'West Yorkshire',
    ],
  },
  {
    region: 'Scotland',
    counties: [
      'Aberdeenshire',
      'Angus',
      'Argyll',
      'Ayrshire',
      'Banffshire',
      'Berwickshire',
      'Buteshire',
      'Caithness',
      'Clackmannanshire',
      'Dumfriesshire',
      'Dunbartonshire',
      'East Lothian',
      'Fife',
      'Inverness-shire',
      'Kincardineshire',
      'Kinross-shire',
      'Kirkcudbrightshire',
      'Lanarkshire',
      'Midlothian',
      'Moray',
      'Nairnshire',
      'Orkney',
      'Peebleshire',
      'Perthshire',
      'Renfrewshire',
      'Ross and Cromarty',
      'Roxburghshire',
      'Selkirkshire',
      'Shetland',
      'Stirlingshire',
      'Sutherland',
      'West Lothian',
      'Wigtownshire',
    ],
  },
  {
    region: 'Wales',
    counties: [
      'Isle of Anglesey (Ynys Môn)',
      'Gwynedd',
      'Conwy',
      'Denbighshire (Sir Ddinbych)',
      'Flintshire (Sir y Fflint)',
      'Wrexham (Wrecsam)',
      'Ceredigion',
      'Powys',
      'Pembrokeshire (Sir Benfro)',
      'Carmarthenshire (Sir Gaerfyrddin)',
      'Swansea (Abertawe)',
      'Neath Port Talbot (Castell-nedd Port Talbot)',
      'Bridgend (Pen-y-bont ar Ogwr)',
      'Vale of Glamorgan (Bro Morgannwg)',
      'Rhondda Cynon Taff',
      'Cardiff (Caerdydd)',
      'Merthyr Tydfil (Merthyr Tudful)',
      'Caerphilly (Caerffili)',
      'Newport (Casnewydd)',
      'Torfaen (Tor-faen)',
      'Blaenau Gwent',
      'Monmouthshire (Sir Fynwy)',
    ],
  },
  {
    region: 'Northern Ireland',
    counties: [
      'Antrim',
      'Armagh',
      'Down',
      'Fermanagh',
      'Londonderry',
      'Tyrone',
    ],
  },
];

export const countriesWithRegions = [
  {
    name: 'United Kingdom',
    shortName: 'UK',
    states: ['England', 'Northern Ireland', 'Scotland', 'Wales'],
  },
  {
    name: 'United States',
    shortName: 'USA',
    states: [
      'Alabama',
      'Alaska',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'Florida',
      'Georgia',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Pennsylvania',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virginia',
      'Washington',
      'Washington DC',
      'West Virginia',
      'Wisconsin',
      'Wyoming',
    ],
  },
  {
    name: 'Canada',
    shortName: 'Canada',
    states: [
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Labrador',
      'Northwest Territories',
      'Nova Scotia',
      'Nunavut',
      'Ontario',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan',
      'Yukon',
    ],
  },
  {
    name: 'Australia',
    shortName: 'Australia',
    states: [
      'Australian Capital Territory',
      'Jervis Bay Territory',
      'New South Wales',
      'Northern Territory',
      'Queensland',
      'South Australia',
      'Tasmania',
      'Victoria',
      'Western Australia',
    ],
  },
];
